import React from 'react';
import './SideLayout.less';
import HwzComponent from '../../common/component/HwzComponent';
import Preference from '../../common/model/preference/Preference';
import Moon from '../../common/model/global/Moon';
import DefaultLogoPng from '../../assets/image/logo.png';
import Sun from '../../common/model/global/Sun';
import { Link } from 'react-router-dom';
import { UserRole } from '../../common/model/user/UserRole';
import { Menu } from 'antd';
import MenuItem from '../../common/menu/MenuItem';
import User from '../../common/model/user/User';
import MenuManager from '../../common/menu/MenuManager';
import { InfoCircleOutlined } from '@ant-design/icons';
import Lang from '../../common/model/global/Lang';
import AboutModal from './widget/AboutModal';
import Capacity from './widget/Capacity';
import { withRouter, RouteComponentProps } from 'react-router-dom'; // 添加 withRouter

const { SubMenu, Item } = Menu;

interface IProps extends RouteComponentProps {} // 扩展 RouteComponentProps

interface IState {}

class SideLayout extends HwzComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
  }

  onSelect(param: any) {
    console.log('1. onSelect called, key =', param.key);
  
    if (param.key === 'about') {
      AboutModal.open();
      return;
    }
  
    const menuManager = MenuManager.getSingleton();
    console.log('2. menuManager got');
    menuManager.selectMenu(param.key);
    console.log('3. selectMenu done');
  
    if (param.key === '/user/logout') {
      // 1. 立即重置前端用户状态
      const guestUser = new User();
      guestUser.role = UserRole.GUEST;
      Moon.getSingleton().user = guestUser;
      // 2. 清除菜单缓存
      MenuManager.getSingleton().clearCachedPreference();
      // 3. 跳转到登录页（此时 user.role 已是 GUEST，不会触发自动跳转）
      this.props.history.push('/user/login');
      // 4. 异步调用后端退出接口（静默执行）
      setTimeout(() => new User().httpLogout(() => {}, () => {}), 0);
      this.updateUI();
      return;
    }
  
    console.log('6. 进入普通菜单分支, key =', param.key);
    this.props.history.push(param.key);
    this.updateUI();
    console.log('7. 普通菜单跳转完成');
  }

  onOpenChange(openKeys: string[]) {
    const menuManager: MenuManager = MenuManager.getSingleton();
  
    // 获取当前展开的菜单项
    const currentExpandedKeys = Array.from(menuManager.getExpandedKeys());
  
    // 找到新展开的菜单项
    const newlyOpenedKey = openKeys.find((key) => !currentExpandedKeys.includes(key));
  
    // 找到被关闭的菜单项
    const newlyClosedKey = currentExpandedKeys.find((key) => !openKeys.includes(key));
  
    // 如果有新展开的菜单项，则展开它
    if (newlyOpenedKey) {
      menuManager.toggleMenuItemExpansion(newlyOpenedKey);
    }
  
    // 如果有被关闭的菜单项，则关闭它
    if (newlyClosedKey) {
      menuManager.toggleMenuItemExpansion(newlyClosedKey);
    }
  
    this.updateUI();
  }

  render() {
      // 分享页面不渲染侧边栏
  if (this.props.location.pathname.startsWith('/share/detail')) {
    return null;
  }
    const menuManager: MenuManager = MenuManager.getSingleton();
    const menuItems: MenuItem[] = menuManager.getMenuItems();
    const preference: Preference = Moon.getSingleton().preference;
    const user: User = Moon.getSingleton().user;

    // 获取当前展开的菜单项的 key
    const expandedKeys = Array.from(menuManager.getExpandedKeys());

    // 调试输出当前路径和菜单项
    console.log('SideLayout: 当前路径:', this.props.location.pathname);
    console.log('SideLayout: 菜单项数量:', menuItems.length);

    return (
      <div
        className={`layout-side ${
          Sun.getSingleton().showDrawer ? 'show-drawer' : ''
        }`}
      >
        {preference.installed ? (
          <div>
            <div className="avatar-area">
              <Link className="username-text" to={'/user/detail/' + user.uuid}>
                <img
                  alt="avatar"
                  className="avatar-small"
                  src={user.getAvatarUrl()}
                />
              </Link>
            </div>
            <div className="username-area">
              {user.role === UserRole.GUEST ? (
                Lang.t('nologin')
              ) : (
                <Link to={'/user/detail/' + user.uuid}>
                  <span className="username-text">{user.username}</span>
                </Link>
              )}
            </div>
          </div>
        ) : (
          <div className="install-area">
            <img alt="avatar" className="install-logo" src={DefaultLogoPng} />
          </div>
        )}

        <Menu
          theme="dark"
          style={{ backgroundColor: '#00050a' }} // 设置背景颜色
          mode="inline"
          selectedKeys={menuManager.getSelectedKeys()}
          openKeys={expandedKeys} // 设置当前展开的菜单项
          onOpenChange={this.onOpenChange.bind(this)} // 处理菜单展开和缩起
          onClick={this.onSelect.bind(this)}
        >
          {menuItems.map((menuItem: MenuItem) => {
            if (
              menuItem.url === '/bin/list' &&
              !preference.getRecycleBinStatus()
            ) {
              return null;
            }

            // 检查是否有子菜单
            if (menuItem.children && menuItem.children.length > 0) {
              // 如果有子菜单，使用 SubMenu
              return (
                <SubMenu
                  key={menuItem.key} // 使用菜单项的 key 作为唯一标识
                  icon={menuItem.icon}
                  title={menuItem.name}
                >
                  {menuItem.children.map((childItem) => (
                    <Menu.Item key={childItem.url}>
                      {childItem.icon}
                      <span>{childItem.name}</span>
                    </Menu.Item>
                  ))}
                </SubMenu>
              );
            }

            // 如果没有子菜单，返回 Menu.Item
            return (
              <Menu.Item key={menuItem.url}>
                {menuItem.icon}
                <span>{menuItem.name}</span>
              </Menu.Item>
            );
          })}
          {Sun.getSingleton().isMobile && (
            <Menu.Item className="visible-xs" key="about">
              <InfoCircleOutlined />
              <span>{Lang.t('layout.about')}</span>
            </Menu.Item>
          )}
        </Menu>
      </div>
    );
  }
}

// 使用 withRouter 包装组件，以获取 history 和 location 属性
export default withRouter(SideLayout);